import styled from 'styled-components';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { colors } from '@/styles';

export const List = styled(TabsPrimitive.List)`
  display: flex;
  gap: 1px;
  margin-bottom: -1px;
  border-bottom: 1px solid ${colors.secondary.lightGray3};
`;

export const Trigger = styled(TabsPrimitive.Trigger)`
  all: unset;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${colors.secondary.darkGray1};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid transparent;
  border-radius: 6px 6px 0 0;
  margin-bottom: -1px;
  height: 20px;
  line-height: 20px;

  &[data-state='active'] {
    border: 1px solid ${colors.secondary.lightGray3};
    border-bottom: 1px solid white;
    background: white;
  }
`;

export const Content = styled(TabsPrimitive.Content)`
  &[data-state='active'] {
    padding: 16px 0;
  }
`;
